export const environment = {
  production: false,
  serverUrl: 'https://devbackapi.progriscom.com',
  application: {},
  config: {
    api: false,
    url: './assets/params/json/crud/',
  },
};
